import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QPointDateFormatPipe } from '@qpoint/i18n';

@Component({
    selector: 'qpoint-changed-info',
    templateUrl: './changed-info.component.html',
    styleUrls: ['./changed-info.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        QPointDateFormatPipe
    ]
})
export class ChangedInfoComponent {
  @Input() userChangedByFirstName: string;
  @Input() userChangedBySurname: string;
  @Input() serviceClientChangedByIdentifier: string;
  @Input() changedDto: Date;
}
